import { Flex, Typography } from "antd"
import React from "react"

import { cn } from "../../../../../utils/cn.ts"

const { Text } = Typography

interface LeadFilterFieldProps {
  label: string
  className?: string
  children: React.ReactNode
}

/**
 * The design names every filter above its control. A placeholder alone stops
 * naming the filter the moment a value is picked, which is what made the row
 * hard to read once several were set.
 */
export function LeadFilterField({
  label,
  className,
  children
}: LeadFilterFieldProps) {
  return (
    <Flex vertical gap={4} className={cn("min-w-0", className)}>
      <Text type={"secondary"} className={"text-xs font-medium"}>
        {label}
      </Text>
      {children}
    </Flex>
  )
}
